'use strict';

function MultiUpdateFieldBtn(auth, $timeout, LocationEditService, $i18next) {
	let $ctrl = this;

	$ctrl.buttonTitle = angular.isUndefined($ctrl.title)
		? $i18next.t('general.update')
		: $i18next.t($ctrl.title);

	let siteName = auth.user.selectedSite.name;

	$ctrl.$onInit = () => {
		$ctrl.showConfirm = false;
	};

	$ctrl.$onChanges = () => {
		$ctrl.showConfirm = false;
	};

	const filterLocations = () => $ctrl.selectedLocations.filter(x => !!x).map(x => x.id || x);

	$ctrl.update = function () {
		const locations = filterLocations();
		$timeout(function () {
			if (locations.length === 0) {
				if (!$ctrl.onlyReturnSelection) {
					$ctrl.onUpdateSingle();
				} else {
					$ctrl.onSuccess(locations);
				}
			} else {
				$ctrl.updateMessage = $i18next.t('listings.location_detail.confirm_update_many', {
					locationAmount: locations.length
				});
				$ctrl.showConfirm = true;
			}
		}, 0);
	};

	const updateMany = function () {
		const locations = filterLocations();
		if ($ctrl.onUpdateMany) {
			return $ctrl.onUpdateMany(locations);
		} else {
			return LocationEditService.updateMultiplePartial(
				siteName,
				$ctrl.locationId,
				locations,
				typeof $ctrl.updateData === 'function' ? $ctrl.updateData() : $ctrl.updateData,
				$ctrl.withoutWork
			);
		}
	};

	$ctrl.updateAll = function () {
		$timeout(function () {
			$ctrl.showConfirm = false;
			if (!$ctrl.onlyReturnSelection) {
				if ($ctrl.beforeUpdateAll) {
					$ctrl.beforeUpdateAll($ctrl.selectedLocations);
				}

				if ($ctrl.selectedLocations.length > 0) {
					updateMany().then($ctrl.onSuccess, $ctrl.onError);
				}
			} else {
				$ctrl.onSuccess($ctrl.selectedLocations.map(x => x.id || x));
			}
		}, 0);
	};
}

MultiUpdateFieldBtn.$inject = ['auth', '$timeout', 'LocationEditService', '$i18next'];

angular.module('pmtPlacesApp.directives').component('pmtMultiUpdateFieldBtn', {
	templateUrl: 'components/multiUpdateField/pmtMultiUpdateFieldBtn.html',
	controller: MultiUpdateFieldBtn,
	bindings: {
		btnDisabled: '<',
		locationId: '<',
		updateData: '<',
		beforeUpdateAll: '<',
		selectedLocations: '<',
		onSuccess: '<',
		onError: '<',
		onlyReturnSelection: '@',
		withoutWork: '<',
		onUpdateSingle: '<',
		onUpdateMany: '<',
		title: '=?'
	}
});
